import { render, staticRenderFns } from "./rent-discount.vue?vue&type=template&id=1d6f05aa&scoped=true"
import script from "./rent-discount.vue?vue&type=script&lang=js"
export * from "./rent-discount.vue?vue&type=script&lang=js"
import style0 from "./rent-discount.vue?vue&type=style&index=0&id=1d6f05aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f05aa",
  null
  
)

export default component.exports